export default __webpack_public_path__ + "static/media/logoSidenav.052afca3.png";